import { useEffect, useMemo, useState } from 'react'
import CustomToolTip from '../../../../CommonComponents/CustomToolTip'
import { getUtcFormattedDate } from '../../utils/helperFunction'
import useOrbitAnimationDetails from '../../hooks/useOrbitAnimationDetails'

const ScenarioLiveTimeIndicator = () => {
    const { orbitAnimationDetails, getViewerCurrentTime } = useOrbitAnimationDetails()
    const [viewerEpoch, setViewerEpoch] = useState(0)
    const showAnimationDetails = useMemo(() => orbitAnimationDetails.showAnimationDetails, [orbitAnimationDetails.showAnimationDetails])

    useEffect(() => {
        if (!showAnimationDetails) {
            setViewerEpoch(0)
            return
        }

        let rafId: number | null = null
        const tick = () => {
            const currentEpoch = Math.floor(getViewerCurrentTime?.() || 0)
            setViewerEpoch((prev) => prev === currentEpoch ? prev : currentEpoch)
            rafId = requestAnimationFrame(tick)
        }

        tick()

        return () => {
            if (rafId) cancelAnimationFrame(rafId)
        }
    }, [getViewerCurrentTime, showAnimationDetails])

    if (!showAnimationDetails) return null
    return (
        <div className='scenario__timeline__header__timeDetails__container live'>
            <div className='scenario__timeline__header__time__label'>
                <CustomToolTip title='Current Time'>
                    Live
                </CustomToolTip>
            </div>
            <div className='scenario__timeline__header__time__details'>
                {viewerEpoch ? getUtcFormattedDate(viewerEpoch) : '--'}
            </div>
        </div>
    )
}

export default ScenarioLiveTimeIndicator
